export default __webpack_public_path__ + "static/media/ldo_ADJ_nEN_Cff.e8b5cd76.svg";